import { SkeletonLoader } from './skeleton-loader';
import { SkeletonLoaderProvider, SkeletonLoaderProviderProps } from './skeleton.provider';

export const SkeletonLoaders = ({ children, ...rest }: SkeletonLoaderProviderProps) => (
  <SkeletonLoaderProvider {...rest}>{children}</SkeletonLoaderProvider>
);

SkeletonLoaders.Loader = SkeletonLoader;
